module.exports = __webpack_public_path__ + "static/media/coverImg.8609db5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/samsung-galaxy/coverImg.png
// module id = 2144
// module chunks = 0